@if (dialogType === 1) {
  <div class="dialog">
    <h2 mat-dialog-title>
      <b>{{ newSerialDialogTitle }}</b>
    </h2>
    <div class="dialog-content">
      <mat-dialog-content>
        <div>
          <span class="input-title">{{ newSerialInputTitle }}</span>
          <serial-search (serialCheck)="onSerialCheck($event)"></serial-search>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button (click)="onCancel()" class="cancel-btn">
          {{ cancelButtonText }}
        </button>
        <button
          mat-button
          (click)="onConfirm()"
          class="confirm-btn"
          [disabled]="!validSerial"
        >
          {{ startButtonText }}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
}
@if (dialogType === 2) {
  @if (saveTrigger) {
    <div class="loading-spinner">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
  } @else {
    <div class="dialog">
      <h2 mat-dialog-title>
        <b>{{ photoAttachTitle }}</b> {{ optionalText }}
      </h2>
      <div class="dialog-messages">
        <div class="photo-message">{{ photoAttachMessage }}</div>
        <div class="file-type-message">{{ fileTypeMessage }}</div>
        <div class="file-type-message">{{ photoLimitMessage }}</div>
        <div class="file-type-message">{{ photoMaxMessage }}</div>
      </div>
      <div class="photo-action-container">
        <div class="photo-actions">
          <div>{{ addNewPhotoText }}</div>
          <input
            type="file"
            accept="image/*"
            #fileUpload
            multiple
            (change)="uploadPhoto($event)"
            hidden
          />
          <button mat-button class="photo-btn" (click)="fileUpload.click()">
            <mat-icon class="add-photo-icon">add_a_photo</mat-icon>
          </button>
        </div>
      </div>

      @if (photosAttached) {
        <div class="attached-photo-container">
          @for (photo of attachedPhotos; track photo) {
            <div class="attached-photo">
              <span class="photo-name" (click)="previewPhoto(photo)">{{
                nameValidation(photo)
              }}</span>

              <button
                mat-button
                class="remove-photo-btn"
                (click)="removePhoto(photo)"
              >
                <mat-icon class="remove-photo-icon">close</mat-icon>
              </button>
            </div>
            @if (deleteVisible && deleteError) {
              <div class="photo-error">{{ deleteErrorMsg }}</div>
            }
          }
        </div>
      }

      @if (photoError) {
        <div class="photo-error">{{ photoErrorMsg }}</div>
      }

      @if (previewVisible) {
        <div class="image-preview-overlay" (click)="closePreview()">
          <div
            class="image-preview-container"
            (click)="$event.stopPropagation()"
          >
            <button
              mat-button
              class="image-preview-close"
              (click)="closePreview()"
            >
              <mat-icon>close</mat-icon>
            </button>
            @if (previewLoading) {
              <div class="image-preview-loading">
                <mat-spinner diameter="40"></mat-spinner>
              </div>
            }
            @if (previewError) {
              <div class="image-preview-error">{{ photoPreviewErrorMsg }}</div>
            }
            @if (previewUrl && !previewError) {
              <img
                [src]="previewUrl"
                alt="Photo preview"
                (error)="onPreviewImageError()"
              />
            }
          </div>
        </div>
      }

      <div class="signoff-btns">
        <button
          mat-button
          (click)="onCancel()"
          class="cancel-btn"
          [disabled]="saveTrigger"
        >
          {{ cancelButtonText }}
        </button>
        <button
          mat-button
          cdkFocusInitial
          (click)="savePhoto()"
          class="confirm-btn"
          [disabled]="saveTrigger || !changesMade"
        >
          {{ saveBtnText }}
        </button>
      </div>
    </div>
  }
}
@if (dialogType === 3) {
  <div>
    <h2 mat-dialog-title>
      <b>{{ odDefectTitle }}</b>
    </h2>
    <div>
      <mat-dialog-content class="defect-dialog-style">
        <div class="defect-msg">{{ odDefectMessage }}</div>
        <div>
          <dropdown-component
            [dropdownType]="'defect'"
            [observedDefectTasks]="observedDefectList"
            (defectSelected)="onDefectSelected($event)"
          >
          </dropdown-component>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button (click)="onCancel()" class="cancel-btn">
          {{ cancelButtonText }}
        </button>
        <button
          mat-button
          (click)="onConfirm()"
          class="confirm-btn"
          [disabled]="!selectedDefectTask"
        >
          {{ confirmButtonText }}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
}
@if (dialogType === 4) {
  <div class="signoff-dialog">
    <h2 mat-dialog-title>
      <b>{{ finalSignOffTitle }}</b>
    </h2>
    <div class="signature-content">
      <div class="download-defects-container">
        <div>Download Defects:</div>
        <button mat-icon-button class="export-btn" (click)="generatePdfForSignOff(dialogData)"
        [disabled]="noDefectsForSignOff()">
          <mat-icon class="export-icon">download_2</mat-icon>
        </button>
      </div>
      <hr class="download-line" />
      <div class="signoff-msg">
        <span>{{ finalSignOffMessage }}</span>
      </div>
      <div class="signature-box">
        <div class="signature-area">
          @if (isSignatureGenerated) {
            <span class="signature">{{ signature }}</span>
          }
        </div>
        <hr class="signature-line" />
        <span class="label">{{ finalSignOffPlaceholder }}</span>
        <mat-checkbox
          class="sign-chkbox"
          [checked]="isSignatureGenerated"
          (change)="generateSignature($event)"
        >
        </mat-checkbox>
      </div>
    </div>

    <div class="signoff-btns">
      <button mat-button (click)="onCancel()" class="cancel-btn">
        {{ cancelButtonText }}
      </button>
      <button
        mat-button
        (click)="onConfirm()"
        class="confirm-btn"
        [disabled]="!isSignatureGenerated"
      >
        {{ confirmButtonText }}
      </button>
    </div>
  </div>
}
@if (dialogType === 5) {
  <div class="station-dialog">
    <h2 mat-dialog-title>
      <b>{{ designateTitle }}</b>
    </h2>
    <div>
      <mat-dialog-content class="defect-dialog-style">
        <div class="dropdown-container">
          <dropdown-component
            [dropdownType]="'station'"
            [stations]="dialogData.dataList"
            (stationSelected)="onStationSelected($event)"
          >
          </dropdown-component>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button (click)="onCancel()" class="cancel-btn">
          {{ cancelButtonText }}
        </button>
        <button
          mat-button
          (click)="onConfirm()"
          class="confirm-btn"
          [disabled]="!selectedStation"
        >
          {{ startButtonText }}
        </button>
      </mat-dialog-actions>
    </div>
  </div>
} @if (dialogType === 6) {
  <div class="photo-preview">
      @if (previewVisible) {
        <div class="image-preview-overlay" (click)="closePreview()">
          <div
            class="image-preview-container"
            (click)="$event.stopPropagation()"
          >
            <button
              mat-button
              class="image-preview-close"
              (click)="closePreview()"
            >
              <mat-icon>close</mat-icon>
            </button>
            @if (previewLoading) {
              <div class="image-preview-loading">
                <mat-spinner diameter="40"></mat-spinner>
              </div>
            }
            @if (previewError) {
              <div class="image-preview-error">{{ photoPreviewErrorMsg }}</div>
            }
            @if (previewUrl && !previewError) {
              <img
                [src]="previewUrl"
                alt="Photo preview"
                (error)="onPreviewImageError()"
              />

              
              <button class="download-button" mat-button (click)="downloadImg()">
                <mat-icon class="download-icon">download</mat-icon>
              </button>
            }
          </div>
        </div>
      }
  </div>
} @if(dialogType === 7) {
  <div class="pdf-dialog-container">
    <div class="upper-container">
      <h2 mat-dialog-title class="dialog-title-download">{{pdfDialogTitle}}</h2>
      <button class="close-dialog" mat-button (click)="onCancel()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <mat-dialog-content class="download-content">
      @if(allSerials) {
        <div #pdfContent [id]="pdfElementId" class="pdf-element-container">
          @for(serial of dialogData.dataList; track serial) {
            <div class="serial-number-container">
              <div class="serial-number">{{ serial.serialNumber }}</div>
              @for(section of serial.sectionList; track section) {
                @for(station of section.Stations; track station) {
                  @if(station.DefectedTasks.length > 0) {
                    <div class="section-name">{{ 'Section ' + section.SectionName }}</div>
                    <div class="station-name">{{ station.Name }}</div>
                    @for(defect of station.DefectedTasks; track defect) {
                      <div class="defect-container">
                        <div class="defect-name-container">
                          <div class="defect-name-styling">{{ defectNameLabel }}</div>
                          <div class="defect-name main-text">{{ getTaskExecutionName(station, defect.TaskExecutionId, defect.TaskName) }}</div>
                        </div>
                        <ul class="two-column-list">
                          <li>
                            <div class="label-styling">{{ deptLabel }}</div>
                            @if(defect.DepartmentId) {
                              <div class="main-text">{{ formatDefectDepartment(defect.DepartmentId) }}</div>
                            } @else {
                              <div class="na-styling">N/A</div>
                            }
                          </li>
                          <li>
                            <div class="label-styling">{{ locationLabel }}</div>
                            <div class="main-text">{{ ' ' + formatDefectLocation(defect.LocationId) }}</div>
                          </li>
                          <li>
                            <div class="label-styling">{{ quantityLabel }}</div>
                            <div class="main-text">{{ defect.DefectQuantity }}</div>
                          </li>
                          <li>
                            <div class="label-styling">{{ statusLabel }}</div>
                            @if(defect.StatusId) {
                              <div class="main-text">{{ formatDefectStatus(defect) }}</div>
                            }
                          </li>
                          <li>
                            <div class="label-styling">{{ descriptionLabel }}</div>
                            @if(defect.Description) {
                              <div class="main-text">{{ defect.Description }}</div>
                            } @else {
                              <div class="na-styling">{{ 'N/A' }}</div>
                            }
                          </li>
                        </ul>
                        @if(photoAttachCheck(defect.AttachmentLocationKeys)) {
                          <div class="label-styling">{{ imageLabel }}</div>
                          <div class="image-container">
                            @for(image of defect.AttachmentLocationKeys; track image) {
                              @if (attachmentUrls.get(image); as imageUrl) {
                                <img
                                  [src]="imageUrl"
                                  alt="Defect attachment"
                                  class="defect-image"
                                />
                              } @else if (attachmentErrors.has(image)) {
                                <div class="image-error">Unable to load attachment</div>
                              } @else {
                                <mat-spinner diameter="24"></mat-spinner>
                              }
                            }
                          </div>
                        }
                      </div>
                    }
                  }
                }
              }
            </div>
          }
        </div>
      } @else {
        <div #pdfContent [id]="pdfElementId" class="pdf-element-container">
          <div class="serial-number">
            {{ currentSerial + ' :' }}
              @if(dialogData.sectionName) {
                  {{ currentZoneName + '-' + dialogData.sectionName }}
              } @else {
                  {{ currentZoneName }}
              }
          </div>
          @for(station of dialogData.dataList; track station) {
            @if(station.DefectedTasks.length > 0) {
            <div class="station-name">
              {{ station.Name }}
            </div>
              @for(defect of station.DefectedTasks; track defect) {
                <div class="defect-container">
                  <div class="defect-name-container">
                    <div class="defect-name-styling">{{ defectNameLabel }}</div>
                    <div class="defect-name main-text">{{ getTaskExecutionName(station, defect.TaskExecutionId, defect.TaskName) }}</div>
                  </div>
                  <ul class="two-column-list">
                    <li>
                      <div class="label-styling">{{ deptLabel }}</div>
                      @if(defect.DepartmentId) {
                        <div class="main-text">{{ formatDefectDepartment(defect.DepartmentId) }}</div>
                      } @else {
                        <div class="na-styling">N/A</div>
                      }
                    </li>
                    <li>
                      <div class="label-styling">{{ locationLabel }}</div>
                      @if(defect.LocationId) {
                        <div class="main-text">{{ formatDefectLocation(defect.LocationId) }}</div>
                      } @else {
                        <div class="na-styling">N/A</div>
                      }
                    </li>
                    <li>
                      <div class="label-styling">{{ quantityLabel }}</div>
                      <div class="main-text">{{ defect.DefectQuantity }}</div>
                    </li>
                    <li>
                      <div class="label-styling">{{ statusLabel }}</div>
                      @if(defect.StatusId) {
                        <div class="main-text">{{ formatDefectStatus(defect) }}</div>
                      }
                    </li>
                    <li>
                      <div class="label-styling">{{ descriptionLabel }}</div>
                      @if(defect.Description) {
                        <div class="main-text">{{ defect.Description }}</div>
                      } @else {
                        <div class="na-styling">N/A</div>
                      }
                    </li>
                  </ul>
                  @if(photoAttachCheck(defect.AttachmentLocationKeys)) {
                    <div class="label-styling">{{ imageLabel }}</div>
                    <div class="image-container">
                      @for(image of defect.AttachmentLocationKeys; track image) {
                        @if (attachmentUrls.get(image); as imageUrl) {
                          <img
                            [src]="imageUrl"
                            alt="Defect attachment"
                            class="defect-image"
                          />
                        } @else if (attachmentErrors.has(image)) {
                          <div class="image-error">Unable to load attachment</div>
                        } @else {
                          <mat-spinner diameter="24"></mat-spinner>
                        }
                      }
                    </div>
                  }
                </div>
              }
            }
          }
        </div>
      }
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button (click)="onCancel()" class="cancel-btn">
        {{ cancelButtonText }}
      </button>
      <button
        mat-button 
        [disabled]="loadingPdfImgs || pdfLoading"
        (click)="onDownloadPdf(pdfContent)"
        class="download-btn">
        {{ pdfDialogButton }}
      </button>
    </mat-dialog-actions>
  </div>
  @if (pdfLoading) {
    <div class="pdf-loading-overlay">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }
}
